export const DEFAULT_USER_CONFIG = 'DefaultUserConfig';
